import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import Icon from 'snippets/icon/icon'

function NoticeGlobal() {
  const [type, setType] = useState('success')
  const [content, setContent] = useState('')
  const [classCustom, setClassCustom] = useState('')
  const [isDisplayed, setIsDisplayed] = useState(false)

  useEffect(() => {
    globalEmitter.on(emitterProps.notice.global, (value) => {
      if (value.type) {
        setType(value.type)
      }

      if (value.content) {
        setContent(value.content)
      }

      setIsDisplayed(true)

      if (value.duration) {
        setTimeout(() => {
          setIsDisplayed(false)
        }, value.duration)
      } else {
        setTimeout(() => {
          setIsDisplayed(false)
        }, 5000)
      }

      if (value.classCustom) {
        setClassCustom(value.classCustom)
      }
    })
  }, [])

  return isDisplayed && (
    <div className={`fixed left-0 right-0 bottom-6 z-[80] mx-auto flex max-w-96 justify-center md:bottom-20 ${classCustom}`}>
      <div className="relative notice-main">
        <div className={`absolute left-0 min-w-1.5 h-full rounded-l -ml-px ${type === 'error' ? 'bg-error-content' : 'bg-success-content'}`}></div>
        {type === 'error'
          ? <Icon className="size-8 text-error-content" name="icon-error" viewBox="0 0 32 32" />
          : <Icon className="size-8 text-success-content" name="icon-success" viewBox="0 0 32 32" />
        }
        <div className="notice-main-content pl-4">{content}</div>
      </div>
    </div>
  )
}

export default NoticeGlobal
